import React from 'react';
import type { SvgIconProps } from '@mui/material';
import GamesIcon from '@mui/icons-material/Games';
import AssessmentIcon from '@mui/icons-material/Assessment';
import TimelineIcon from '@mui/icons-material/Timeline';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import HubIcon from '@mui/icons-material/Hub';
import CollectionsIcon from '@mui/icons-material/Collections';
import FolderIcon from '@mui/icons-material/Folder';
import ScienceIcon from '@mui/icons-material/Science';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

// JSON には React 要素を入れられないため、文字列名 → アイコンコンポーネントのマップで解決する。
// 管理画面の選択肢もこのキー一覧から生成する。
const IconMap: Record<string, React.ComponentType<SvgIconProps>> = {
  Games: GamesIcon,
  Assessment: AssessmentIcon,
  Timeline: TimelineIcon,
  AccountCircle: AccountCircleIcon,
  EmojiEvents: EmojiEventsIcon,
  Hub: HubIcon,
  Collections: CollectionsIcon,
  Folder: FolderIcon,
  Science: ScienceIcon,
  AutoAwesome: AutoAwesomeIcon,
};

export const FEATURE_ICON_NAMES = Object.keys(IconMap);

export const FeatureIcon: React.FC<{ name?: string } & SvgIconProps> = ({ name, ...props }) => {
  const Icon = (name && IconMap[name]) || AutoAwesomeIcon;
  return <Icon {...props} />;
};
